import React from 'react'
import { makeStyles } from '@mui/styles'

import AppShell from 'components/AppShell'
import { Box } from '@mui/material';
import ShortlistTodo from './ShortlistTodo';
import ResumeHistory from './ResumeHistory';
import ShortlistingBanner from './ShortlistingBanner';
import ResumeGeneratorBanner from './ResumeGeneratorBanner';
import { useState } from 'react';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  root : {
    display : 'flex',
    flexDirection : 'column',
    gap : theme.spacing(4),
    width : '100%',
  }
}));


const ShortlistingGenie = () => {
  const classes = useStyles();
  const [refresh , setRefresh] = useState(false)

  useEffect(() => {
    if(refresh){
      setRefresh(false)
    }
  },[refresh])

  return (
    <AppShell headerLabel='Shortlisting Genie'>
        <Box className={classes.root}>
          <ShortlistingBanner/>
          <ResumeGeneratorBanner/>
          <ShortlistTodo refresh={refresh} setRefresh={setRefresh}/>
          <ResumeHistory refresh={refresh}/>
        </Box>      
    </AppShell>
  )
}

export default ShortlistingGenie